// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f93604d","667":"a9d4aa96"}[chunkId] + ".chunk.js";
};